import { GivelifyPaper } from '@givelify/ui';
import { styled } from '@mui/material';

export const CoveredFeesContainer = styled(GivelifyPaper)(({ theme }) => ({
    display: 'flex',
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('mobile')]: {
        flexDirection: 'column',
        gap: theme.spacing(4),
    },
}));

export const CoveredFeesContent = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    maxWidth: 432,
}));

export const CoveredFeesRow = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
}));

export const CoveredFeesRadioContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    cursor: 'pointer',
}));
